// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"ef7e773a","160":"a254a41c","227":"33de75bd"}[chunkId] + ".chunk.css";
};